import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { useWebsite } from '../../hooks/useWebsite';
import { DisplayWhenValid } from './DisplayWhenValid';

interface Props {
  noBorder?: boolean;
  hasInitialValue?: boolean;
  className?: string;
}

export const CguStatement: FC<Props> = ({ noBorder, hasInitialValue, className }) => {
  const website = useWebsite();

  if (!website?.cgu?.inputFrontActive) return null;

  const statement = (
    <div
      className={twMerge(
        'text-gray-600 text-xs mb-3 text-right',
        noBorder ? 'mx-2 mt-0' : 'mt-3',
        className,
      )}
      // @TODO change this edition ==> major security breach
      dangerouslySetInnerHTML={{
        __html: website.cgu?.inputFrontTxt as string,
      }}
    />
  );

  return hasInitialValue != null ? (
    <DisplayWhenValid hasInitialValue={hasInitialValue}>{statement}</DisplayWhenValid>
  ) : (
    statement
  );
};
